import React from "react";
import Fade from "react-reveal/Fade";
import { BestSellerCard } from "./BestSellerCard";
import { ProductItemsSkeleton } from "../user/ParcoursAchat/ParcoursAchat";
import { useGetProductListQuery } from "../../utils/api/product/product.api";

const BestSellers: React.FC = () => {
  const { data, isLoading } = useGetProductListQuery({
    page: 1,
    limit: 4,
    orderBy: "-nombre_ventes",
  });

  return (
    <section className="best-sellers-section">
      <div className="container-easy-market">

        <div className="best-sellers-header">
          <Fade bottom>
            <h2 className="best-sellers-title">Nos meilleures ventes</h2>
          </Fade>
        </div>

        <div className="best-sellers-section-grid ">
          {isLoading && <ProductItemsSkeleton />}
          {!isLoading &&
            data?.results?.map((produit, key) => (
              <Fade bottom delay={key * 50} key={produit?.id ?? key}>
                <BestSellerCard item={produit} />
              </Fade>
            ))}
        </div>

      </div>
    </section>
  );
};

export default BestSellers;